import { FC, useRef, useState } from 'react';
import clsx from 'clsx';
import { useClickAway } from 'react-use';
import { Input } from '..';
import { ElementsButton, Icon } from '../../../../../UI';

interface AddInputProps {
  placeholder: string;

  onChange?(this: void, s: string): void;
  onSave?(value: string): void;
}
export const AddInput: FC<AddInputProps> = ({ placeholder, onChange, onSave }) => {
  const [text, setText] = useState('');
  const [focused, setFocused] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useClickAway(containerRef, () => setFocused(false));

  const submit = () => {
    if (!text.length) return;

    onSave?.(text);
    if (onChange) onChange('');
    setText('');
  };

  return (
    <div
      ref={containerRef}
      className="add-input-container mb-1 overflow-hidden rounded-md bg-darkMode-gray-dark w-[107.3%] sm:w-[104.3%] flex items-center "
    >
      <div className="relative flex-1 min-w-0">
        <Input
          leading={<Icon icon="add" className={'!text-palette-500'} />}
          defaultValue={text}
          onChange={(e) => {
            const value = e.target.value;
            setText(value);
            onChange?.(value);
          }}
          inputProps={{
            placeholder,
            value: text,
            onFocus: () => setFocused(true),
            onKeyDown: (e) => {
              if (e.key === 'Enter') submit();
            },
          }}
          className="dark:!text-darkMode-almostBlack dark:!placeholder-palette-400"
        />
      </div>
      <ElementsButton
        theme="text"
        label="Save"
        onClick={submit}
        className={clsx(
          'whitespace-nowrap transition-opacity duration-100',
          focused ? 'opacity-100' : 'opacity-0 pointer-events-none'
        )}
      />
    </div>
  );
};
